export const exportToExcelConstants = {
	ExportListToExcel: {
		REQUEST : "EXPORT_LIST_TO_EXCEL_REQUEST",
		SUCCESS : "EXPORT_LIST_TO_EXCEL_SUCCESS",
		FAILURE : "EXPORT_LIST_TO_EXCEL_FAILURE",
		СLEAR   : "EXPORT_LIST_TO_EXCEL_CLEAR"
	}
}
